import { render, staticRenderFns } from "./houseDetail.vue?vue&type=template&id=6f54228b&scoped=true&"
import script from "./houseDetail.vue?vue&type=script&lang=ts&"
export * from "./houseDetail.vue?vue&type=script&lang=ts&"
import style0 from "./houseDetail.vue?vue&type=style&index=0&id=6f54228b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f54228b",
  null
  
)

export default component.exports